import React from "react";
import { ReactSVG } from "react-svg";
import locationlist from "@/assets/locationlist.svg";
import { Button } from "@heroui/react";

interface CategoryButtonProps {
    title: string;
    image: string;
    iconColor: string;
    onClick?: () => void;
    isActive?: boolean;
    activeBorderColor?: string;
    className: string;
}

const CategoryButton: React.FC<CategoryButtonProps> = ({
    title,
    image,
    iconColor,
    onClick,
    isActive,
    activeBorderColor,
    className,
}) => {


    
    return (
        <div>
            <Button
                
                title={title}
                className={`relative min-w-[101px] transition mx-2 py-1 px-4 text-white flex items-center justify-center rounded-lg hover:scale-
                    ${isActive ? 'bg-primary' : 'border-[#49454F] border-1 bg-white'} 
                    ${className}`}
                onClick={onClick}
            >
                <span className={`relative font-semibold ${isActive ? 'text-white' : ' text-[#49454F]'}`}>{title}</span>
            </Button>
        </div>
    );
};

export default CategoryButton;
